import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { FindiPurchaseOrderDetail } from "app/_models/purchaseOrders/purchaseOrderDetail";
import { UserModel } from "app/_models/user-model";
import { CrudPurchaseOrderDetailsService } from "app/_services/MasterCrudOps/crud-purchase-order-details.service";
import { UiActionUtils } from "app/shared/utils/ui-action-utils";
import { EditPurchaseOrderDetailsComponent } from "../edit-purchase-order-details/edit-purchase-order-details.component";
declare const swal: any;
import * as XLSX from "xlsx";
@Component({
  selector: "app-list-purchase-order-details",
  templateUrl: "./list-purchase-order-details.component.html",
  styleUrls: ["./list-purchase-order-details.component.css"],
})
export class ListPurchaseOrderDetailsComponent implements AfterViewInit {
  poPageNumber: number;
  poPageSize: number;
  poNumber: string;
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  pageEvent: PageEvent;
  currentPage = 0;
  findiPurchaseOrderId: number = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  isAdminGroupUser: boolean = false;
  findiPurchaseOrderDetails: FindiPurchaseOrderDetail[] = [];
  currentPurchaseOrderDetail:FindiPurchaseOrderDetail;
  currentUser: UserModel;
  displayedColumns: string[] = [
    "ProductName",
    "CategoryName",
    "SubCategoryName",
    "BrandName",
    "OrderQuantity",
    "ReceivedQuantity",
    "WarrantyInMonths",
    "UnitName",
    "UnitPrice",
    "CreatedBy",
    "CreatedOn",
    "UpdatedOn",
    "UpdatedBy",
    "UpdateRemarks",
    "editDetail",
    "deletePoDetail"
  ];
  allColumns = [
    { name: "ProductName", label: "Product" },
    { name: "CategoryName", label: "Category" },
    { name: "SubCategoryName", label: "SubCategory" },
    { name: "BrandName", label: "Brand" },
    { name: "OrderQuantity", label: "Order Qty" },
    { name: "ReceivedQuantity", label: "Rx Qty" },
    { name: "WarrantyInMonths", label: "Warranty" },
    { name: "UnitName", label: "Unit" },
    { name: "UnitPrice", label: "Unit Price" },
    { name: "CreatedBy", label: "Create By" },
    { name: "CreatedOn", label: "Created On" },
    { name: "UpdatedBy", label: "Updated By" },
    { name: "UpdatedOn", label: "Updated On" },
    { name: "updateRemarks", label: "Update Remarks" },
    {name:"editDetail", label:"Edit"},
    {name: "deletePoDetail", label: "Delete"}
  ];

  defaultColumns = [
    "ProductName",
    "CategoryName",
    "SubCategoryName",
    "BrandName",
    "OrderQuantity",
    "ReceivedQuantity",
  ];

  dataSource = new MatTableDataSource<FindiPurchaseOrderDetail>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private readonly datepipe: DatePipe,
    private readonly crudPoDetailService: CrudPurchaseOrderDetailsService,
    private readonly router: Router,
    private readonly  matDialog: MatDialog,
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
    this.findiPurchaseOrderId = Number(history.state.findiPurchaseOrderId);
    this.poPageNumber = Number(history.state.pageNumber);
    this.poPageSize = Number(history.state.pageSize);
    this.poNumber = history.state.poNumber;
  }

  ngAfterViewInit() {
    const saved = localStorage.getItem("findiPoDetailDisplayedColumns");
    this.displayedColumns = saved
      ? JSON.parse(saved)
      : [...this.defaultColumns];
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      // ✅ Only fetch data here, when paginator is ready
      this.getPurchaseOrderDetailsByPoId(
        this.findiPurchaseOrderId,
        this.paginator.pageIndex + 1,
        this.paginator.pageSize
      );
    }
  }

  getPurchaseOrderDetailsByPoId(
    findiPurchaseOrderId: number,
    pageNumber: number,
    pageSize: number
  ) {
    this.isLoaderResult = true;
    const model = {
      currentPage: pageNumber ?? 1,
      pageSize: pageSize ?? 25,
      downloadAllData: false,
      findiPurchaseOrderId: findiPurchaseOrderId,
    };
    this.crudPoDetailService.getPoDetailById(model).subscribe((data) => {
      this.isLoaderResult = false;
      if (!data.didError) {
        const results = data.model || [];
        this.findiPurchaseOrderDetails = results;
        this.dataSource = new MatTableDataSource<FindiPurchaseOrderDetail>(
          results
        );
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // ✅ Add this block to make filter work on formatted fields
        this.dataSource.filterPredicate = (
          data: FindiPurchaseOrderDetail,
          filter: string
        ): boolean => {
          const formatDate = (dateStr: any): string => {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            return (
              this.datepipe.transform(date, "dd-MMM-yyyy")?.toLowerCase() ?? ""
            );
          };

          const searchText = filter.trim().toLowerCase();
          const formattedCreatedOn = formatDate(data.createdOn);
          const formattedUpdatedOn = formatDate(data.updatedOn);

          const dataString = `
                            ${data.productName} ${data.categoryName}
                            ${data.subCategoryName} ${data.brandName}
                            ${data.orderQuantity} ${data.receivedQuantity}
                            ${data.warrantyInMonths} ${data.unitName}
                            ${data.unitPrice} ${formattedCreatedOn}
                             ${formattedUpdatedOn} ${data.createdBy}
                            ${data.updatedBy} ${data.updateRemarks}
                          `.toLowerCase();

          return dataString.includes(searchText);
        };

        if (results.length === 0) {
          this.dataSource.data = [];
          this.paginator.length = 0;
        }
      } else {
        this.dataSource.data = [];

        this.resultLength = 0;
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue;
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getPurchaseOrderDetailsByPoId(
      this.findiPurchaseOrderId,
      this.currentPage + 1,
      this.pageSize
    );
  }

  goBackToPoList() {
    this.router.navigateByUrl("/po", {
      state: {
        findiPurchaseOrderId: this.findiPurchaseOrderId,
        pageNumber: this.poPageNumber,
        pageSize: this.poPageSize,
      },
    });
  }

  updateOrderDetails(e: any, element: any): void
  {
    this.currentPurchaseOrderDetail = element;
    const dialogRef = this.matDialog.open(EditPurchaseOrderDetailsComponent, {
      width: "75%",
      height: "35%",
      disableClose: true,
      data: { editPoOrderDetail:this.currentPurchaseOrderDetail,  poNumber: this.poNumber,  pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
       this.getPurchaseOrderDetailsByPoId(this.findiPurchaseOrderId, result.pageNumber, result.pageSize);
    });
  }
  

softDeletePoDetail(e: any, element: any): void {
  UiActionUtils.confirmWithRemarks("You won't be able to revert this!", (remarks: string) => {
    this.deletePurchaseOrderDetail(e, element, remarks);
  });
}

   deletePurchaseOrderDetail(e: any, element: any, remarks: string): void {
    this.currentPurchaseOrderDetail = JSON.parse(JSON.stringify(element)) ;//deep copy
      this.isLoaderResult = true;
       const model = {
    requestIds: [element.findiPurchaseOrderDetailId],  // assuming `productId` is the correct ID
    remarks: remarks
  };
    this.crudPoDetailService.deletePurchaseOrderDetails(model).subscribe(
      data => {
        if (data.didError) {
          UiActionUtils.showError(data.message, data.additionalMessage);
        } else {
          UiActionUtils.showSuccess(data.message);
           this.getPurchaseOrderDetailsByPoId(this.findiPurchaseOrderId, this.paginator.pageIndex + 1, this.paginator.pageSize);
        }
        this.isLoaderResult = false;
      },
      err => {
        UiActionUtils.showError('Something went wrong', err.message);
        this.isLoaderResult = false;
      }
    );
  }

  exportDataToExcel()
  {
    const workSheet = XLSX.utils.json_to_sheet(
      this.dataSource.data.map((item) => {
        return {
          PoNumber: this.poNumber,
          Product: item.productName,
          Category: item.categoryName,
          SubCategory: item.subCategoryName,
          Brand: item.brandName,
          MeasuringUnitName: item.unitName,
          OrderQuantity: item.orderQuantity,
          ReceivedQuantity: item.receivedQuantity,
          WarrantyInMonths: item.warrantyInMonths,
          UnitPrice: item.unitPrice,
          createdBy:item.createdBy,
          CreatedOn: this.datepipe.transform(item.createdOn,"dd-MMM-yyyy HH:mm:ss"),
          UpdatedBy:item.updatedBy,
          UpdatedOn: this.datepipe.transform(item.updatedOn,"dd-MMM-yyyy HH:mm:ss"),
        };
      })
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
    let fileName =
      "PoDetails_" +
      this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
      ".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

}
